import React from 'react'
import { useState, useMemo, useRef } from 'react'
import { apiClient } from '../../utils/api-config'
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Spinner
} from 'reactstrap'
import 'antd/dist/antd.css'
import { Popconfirm, Select, Spin } from 'antd'
import Header from '../Headers/Header.js'
import { debounce, isEmpty, isNil } from 'lodash'

function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = useState(false)
  const [options, setOptions] = useState([])
  const fetchRef = useRef(0)
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return
        }

        setOptions(newOptions)
        setFetching(false)
      })
    }

    return debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])

  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  )
}

async function fetchUserList(accessToken, value) {
  if(isNil(value) || isEmpty(value) || value.trim().length === 0) {
    return []
  }

  const response = await apiClient.get(`/users?isAdmin=false&take=25&skip=0&text=${encodeURIComponent(value)}`, { headers: { Authorization: `Bearer ${accessToken}`}})
  return response.data.map((user) => ({
    label: `${user.firstName} ${user.lastName} (${user.phoneNumber})`,
    value: user.id
  }))
}

const UserSearchComponent = ({ accessToken, loading, onUserSelected, onClosed, title, primaryBtnText, confirmText  }) => {
  const [userId, setUserId] = useState(null)
  // Dropdown search selected item
  const [selectedUser, setSelectedUser] = useState()

  const onSelectedItemChanged = (selectedUser) => {
    setSelectedUser(selectedUser)
    if(isNil(selectedUser)){
      setUserId(null)
    } else {
      setUserId(selectedUser.value ?? null)
    }
  }

  return (
    <>
      <Header redColor={false} text={title} />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardBody>
                <Form>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-user-search"
                          >
                            Sök efter användare
                          </label>
                          <DebounceSelect
                            showSearch
                            allowClear
                            placeholder="Telefonnummer +46"
                            value={selectedUser}
                            fetchOptions={(value) => fetchUserList(accessToken, value)}
                            onChange={onSelectedItemChanged}
                            style={{ width: '100%' }}
                            disabled={loading}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div className="pl-lg-4">
                    <Row className='align-items-center justify-content-start'>
                      <Col lg="12">
                        {!loading ?
                          <>
                            <Popconfirm
                              placement="topLeft" title={confirmText}
                              onConfirm={(e) => { e.preventDefault(); onUserSelected(userId)}}
                              okText="Ja" cancelText="Nej"
                            >
                              <Button color="primary" type="submit" disabled={userId === null} >
                                {primaryBtnText}
                              </Button>
                            </Popconfirm>
                            <Button color="danger" onClick={onClosed}>Tillbaka</Button>
                          </>
                          : (<Spinner color='danger' type='border' style={{marginLeft: '25px', marginTop: '5px'}}></Spinner>)
                        }
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default UserSearchComponent
